import { ListParams } from '../types/pagination'

import { http } from '@/app/lib/http/client'

export interface UserResponse {
    id: number
    name: string
    last_name: string
    email: string
    phone_number: string
    avatar_url?: string
    use_pin_login: boolean
    role_id: number
    is_active: boolean
    access_all_sucursals: boolean
    sucursal_ids?: number[]
    role?: { id: number, name: string }
    sucursales?: { id: number, name: string }[]
    created_at?: string
    last_access?: string
}

export interface UserPayload {
    name: string
    last_name: string
    email: string
    password?: string
    phone_number: string
    pin?: string
    use_pin_login: boolean
    role_id: number
    is_active: boolean
    access_all_sucursals: boolean
    sucursal_ids?: number[]
    avatar?: File | null
}

function buildFormData(payload: UserPayload | Partial<UserPayload>, isUpdate: boolean = false): FormData {
    const formData = new FormData()
    if (isUpdate) formData.append('_method', 'PUT')

    if (payload.name !== undefined) formData.append('name', payload.name)
    if (payload.last_name !== undefined) formData.append('last_name', payload.last_name)
    if (payload.email !== undefined) formData.append('email', payload.email)
    if (payload.phone_number !== undefined) formData.append('phone_number', payload.phone_number)
    if (payload.role_id !== undefined) formData.append('role_id', String(payload.role_id))
    if (payload.is_active !== undefined) formData.append('is_active', payload.is_active ? '1' : '0')
    if (payload.use_pin_login !== undefined) formData.append('use_pin_login', payload.use_pin_login ? '1' : '0')
    if (payload.access_all_sucursals !== undefined) formData.append('access_all_sucursals', payload.access_all_sucursals ? '1' : '0')
    if (payload.password) formData.append('password', payload.password)
    if (payload.pin) formData.append('pin', payload.pin)

    if (payload.sucursal_ids && payload.sucursal_ids.length > 0) {
        const validIds = payload.sucursal_ids.filter(id => id !== null && id !== undefined);
        validIds.forEach((id) => {
            formData.append('sucursal_ids[]', String(id))
        })
    }

    if (payload.avatar instanceof File) {
        formData.append('avatar', payload.avatar)
    }

    return formData
}

export const userService = {
    async getUsers(params?: ListParams) {
        const response = await http.get('/users', { params })
        return response.data
    },

    async getUser(id: number) {
        const response = await http.get(`/users/${id}`)
        return response.data
    },

    async createUser(payload: UserPayload) {
        const formData = buildFormData(payload)
        const response = await http.post('/users', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        return response.data
    },

    async updateUser(id: number, payload: Partial<UserPayload>) {
        const formData = buildFormData(payload, true)
        const response = await http.post(`/users/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        return response.data
    },

    async deleteUser(id: number) {
        const response = await http.delete(`/users/${id}`)
        return response.data
    },
}
